import { Grid } from "@material-ui/core";
import {
  Box,
  Button,
  Paper,
  Typography,
  Divider,
  TextField,
  MenuItem,
  InputAdornment,
  CircularProgress,
  Link,
  Container,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import flight from "../../../Assets/Services/Flight/flight.svg";
import EastIcon from "@mui/icons-material/East";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import FlightIcon from "@mui/icons-material/Flight";
import LuggageIcon from "@mui/icons-material/Luggage";
import FlightClassIcon from "@mui/icons-material/FlightClass";
import axios from "axios";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FastfoodIcon from "@mui/icons-material/Fastfood";

import { toast } from "react-toastify";

const styles = {
  textField: {
    width: { xs: "100%", md: "100%" },
    borderColor: "#D9D9D9CC",
    backgroundColor: "#FFFFFF",
    "& .MuiInputBase-root": {
      height: { xs: "40px", md: "48px" },
    },
    mt: 1,
  },
};

function RoundBookingDetails() {
  const navigate = useNavigate();
  const location = useLocation();

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedNationality, setSelectedNationality] = useState("");
  const [mobileNumber, setMobileNumber] = useState("+91 ");

  const handleInputChange = (event) => {
    setMobileNumber(event.target.value);
  };

  useEffect(() => {
    axios
      .get("https://restcountries.com/v3.1/all")
      .then((response) => {
        const countryData = response.data.map((country) => ({
          name: country.name.common,
          code: country.cca2,
          nationality: country.demonyms?.eng?.f || "N/A",
        }));
        const sortedCountries = countryData.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setCountries(sortedCountries);
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
      });
  }, []);

  const handleSelect = (event) => {
    setSelectedCountry(event.target.value);
  };

  return (
    <Container px={4} sx={{ marginTop: "6%" }}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography>Service &gt; Flight Booking</Typography>
        <Link
          onClick={() => navigate(-1)}
          sx={{
            textDecoration: "none",
            cursor: "pointer",
            color: "#027BFE",
          }}
        >
          &lt; Back to Search
        </Link>
      </Box>
      <Box mt={2}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={9}>
            <Paper sx={{ p: 2, borderRadius: "10px" }}>
              <Box display={"flex"} justifyContent={"space-between"}>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  gap={2}
                  alignItems={"center"}
                >
                  <Typography fontWeight={300} fontSize={14}>
                    Depart
                  </Typography>
                  <Typography fontWeight={600} fontSize={18}>
                    BOM
                  </Typography>
                  <EastIcon />
                  <Typography fontWeight={600} fontSize={18}>
                    DEL
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  gap={2}
                  alignItems={"center"}
                >
                  <Button
                    sx={{
                      color: "#FF0000",
                      textTransform: "none",
                      borderRadius: "20px",
                    }}
                    endIcon={<ErrorOutlineIcon />}
                  >
                    Fare Rules
                  </Button>
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"row"} gap={2}>
                <Typography>15 Nov</Typography>
                {"|"}
                <Typography>Direct Flight</Typography>
                {"|"}
                <Typography>02h 15m</Typography>
              </Box>

              <Box mb={3} borderRadius={2}>
                <Box mt={2}>
                  <Box
                    sx={{
                      background: "#F5F7FA",
                      p: 1,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box display={"flex"} flexDirection={"row"} gap={2}>
                      <img
                        src={flight}
                        alt={`flight logo`}
                        style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "10px",
                        }}
                      />
                      <Box>
                        <Typography>Akasa Air</Typography>
                        <Typography>QP-1120</Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography>Baggage: 15 KG </Typography>
                      <Typography>Cabin Baggage: 7 KG</Typography>
                    </Box>
                  </Box>
                  <Box
                    display={"flex"}
                    justifyContent={"space-between"}
                    px={4}
                    mt={2}
                  >
                    <Box textAlign={"right"}>
                      <Typography fontWeight={700} fontSize={"20px"}>
                        15:22
                      </Typography>
                      <Typography fontSize={"18px"}>Thu, 14 Nov 24</Typography>
                      <Typography fontWeight={300} fontSize={"12px"}>
                        Mumbai [BOM]
                      </Typography>
                      <Typography fontWeight={300} fontSize={"12px"}>
                        Chhatrapati Shivaji International airport |Mumbai |IN
                      </Typography>
                      <Typography fontWeight={300} fontSize={"12px"}>
                        Terminal ---
                      </Typography>
                    </Box>

                    <Box>
                      <Typography color="#027BFE">7 Hr 45 Min</Typography>
                      <Box display={"flex"} flexDirection={"row"}>
                        <Typography color="#027BFE">- - - - </Typography>
                        <FlightIcon
                          sx={{
                            rotate: "90deg",
                            color: "#027BFE",
                            ml: 0.5,
                          }}
                        />
                        <Typography color="#027BFE"> - - - -</Typography>
                      </Box>
                    </Box>

                    <Box textAlign={"left"}>
                      <Typography fontWeight={700} fontSize={"20px"}>
                        15:22
                      </Typography>
                      <Typography fontSize={"18px"}>Thu, 14 Nov 24</Typography>
                      <Typography fontWeight={300} fontSize={"12px"}>
                        Mumbai [BOM]
                      </Typography>
                      <Typography fontWeight={300} fontSize={"12px"}>
                        Chhatrapati Shivaji International airport |Mumbai |IN
                      </Typography>
                      <Typography fontWeight={300} fontSize={"12px"}>
                        Terminal ---
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
              <Typography
                fontWeight={700}
                fontSize={"20px"}
                fontFamily={"open sans"}
              >
                Traveller Details
              </Typography>
              <Typography
                fontWeight={300}
                fontSize={"14px"}
                fontFamily={"open sans"}
                mt={1}
              >
                Please make sure you enter the Name as per your Government photo
                id.
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Typography
                  fontWeight={600}
                  fontSize={"16px"}
                  fontFamily={"open sans"}
                  mb={1}
                >
                  Adult 1
                </Typography>

                <Grid container spacing={2} mt={2}>
                  <Grid item md={2}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      select
                      label="Title*"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                    >
                      <MenuItem value="Mr">Mr.</MenuItem>
                      <MenuItem value="Ms">Ms.</MenuItem>
                      <MenuItem value="Mrs">Mrs.</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item md={3}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      label="First Name*"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                    />
                  </Grid>
                  <Grid item md={3}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      label="Last Name*"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                    />
                  </Grid>
                  <Grid item md={3}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      type="date"
                      label="DOB*"
                      sx={{
                        ...styles.textField,
                      }}
                    />
                  </Grid>
                  <Grid item md={2}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      select
                      label="Gender*"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                    >
                      <MenuItem value="1">Male</MenuItem>
                      <MenuItem value="2">Female</MenuItem>
                      <MenuItem value="3">Other</MenuItem>
                    </TextField>
                  </Grid>
                  {/* ------------------------------------------- */}
                  <Grid item md={4}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      label="Address Line 1*"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                    />
                  </Grid>

                  <Grid item md={4}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      label="Address Line 2*"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                    />
                  </Grid>

                  <Grid item md={3}>
                    <TextField
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      label="City*"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                    />
                  </Grid>
                  <Grid item md={2}>
                    <TextField
                      select
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      label="Country Code"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        marginBottom: 2,
                        ...styles.textField,
                      }}
                      value={selectedCountryCode}
                      onChange={(e) => setSelectedCountryCode(e.target.value)}
                    >
                      <MenuItem value="">Select Country Code</MenuItem>
                      {countries.map((country) => (
                        <MenuItem key={country.code} value={country.code}>
                          {country.code}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item md={3}>
                    <TextField
                      select
                      InputProps={{ sx: { borderRadius: 2 } }}
                      fullWidth
                      label="Country"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...styles.textField,
                      }}
                      value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}
                    >
                      <MenuItem value="">Select Country</MenuItem>
                      {countries.map((country) => (
                        <MenuItem key={country.name} value={country.name}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Box>
            </Paper>

            <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
              <Typography
                fontWeight={700}
                fontSize={"18px"}
                fontFamily={"open sans"}
              >
                Contact Information
              </Typography>
              <Typography
                fontWeight={300}
                fontSize={"14px"}
                fontFamily={"open sans"}
                mt={2}
              >
                Your ticket and flights information will be sent here..
              </Typography>

              <Box
                display={"flex"}
                flexDirection={"row"}
                mt={2}
                justifyContent={"space-between"}
                gap={2}
              >
                <TextField
                  fullWidth
                  label="Mobile Number*"
                  value={mobileNumber}
                  onChange={handleInputChange}
                  InputProps={{
                    sx: { borderRadius: 4 },
                    startAdornment: (
                      <InputAdornment position="start"></InputAdornment>
                    ),
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    ...styles.textField,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                />
                <TextField
                  InputProps={{ sx: { borderRadius: 2 } }}
                  fullWidth
                  label="Email*"
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    ...styles.textField,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                />
              </Box>
            </Paper>

            <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
              <Typography
                fontWeight={700}
                fontSize={"18px"}
                fontFamily={"open sans"}
              >
                Use GSTIN for this booking (Optional)
              </Typography>
              <Typography
                fontWeight={300}
                fontSize={"14px"}
                fontFamily={"open sans"}
                mt={2}
              >
                Claim credit of GST charges. Your taxes may get updated post
                submitting your GST details
              </Typography>

              <Box
                display={"flex"}
                flexDirection={"row"}
                mt={2}
                justifyContent={"space-between"}
                gap={2}
              >
                <TextField
                  InputProps={{ sx: { borderRadius: 2 } }}
                  label="GSTIN"
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    ...styles.textField,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                />
              </Box>
            </Paper>

            <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
              <Typography
                fontWeight={700}
                fontSize={"18px"}
                fontFamily={"open sans"}
              >
                Addon Services
              </Typography>
              <Box mt={2} display={"flex"} flexDirection={"row"} gap={2}>
                <Button
                  variant="outlined"
                  startIcon={<FastfoodIcon />}
                  sx={{ color: "#027BFE", textTransform: "none" }}
                >
                  Add Meals
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<LuggageIcon />}
                  sx={{ color: "#027BFE", textTransform: "none" }}
                >
                  Add Baggage
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<FlightClassIcon />}
                  sx={{ color: "#027BFE", textTransform: "none" }}
                >
                  Seat Selection
                </Button>
              </Box>
            </Paper>

            <Box display={"flex"} justifyContent={"flex-end"} mt={3} mb={4}>
              <Button
                sx={{
                  background: "#027BFE",
                  color: "white",
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 4,
                  py: 1,
                }}
              >
                Continue to Payment
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Paper sx={{ p: 2, borderRadius: "10px" }}>
              <Box sx={{ mt: 1 }}>
                <Box display={"flex"} flexDirection={"row"} gap={1} mb={1}>
                  <InfoOutlinedIcon sx={{ color: "red" }} />
                  <Typography sx={{ color: "red" }}>
                    Fare may increase/update at the time of booking.
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  Fare Details
                </Typography>
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      mt: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Open Sans",
                        fontSize: "16px",
                      }}
                    >
                      Base Fare
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Open Sans",
                        fontSize: "16px",
                        fontWeight: 700,
                      }}
                    >
                      ₹ 4000
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      mt: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Open Sans",
                        fontSize: "16px",
                      }}
                    >
                      Taxes
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Open Sans",
                        fontSize: "16px",
                        fontWeight: 700,
                      }}
                    >
                      ₹ 4000
                    </Typography>
                  </Box>

                  <Divider sx={{ mt: 1, mb: 1 }} />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      mt: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Open Sans",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Total
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Open Sans",
                        fontSize: "16px",
                        fontWeight: 700,
                      }}
                    >
                      ₹ 4000
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Paper>

            {/* Promo code */}
            <Paper sx={{ p: 2, borderRadius: "10px", mt: 2 }}>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                Promo code
              </Typography>
              <TextField
                InputProps={{ sx: { borderRadius: 2 } }}
                fullWidth
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Code"
                sx={{
                  ...styles.textField,
                  mt: 1,
                }}
              />
              <Button
                sx={{
                  background: "#027BFE",
                  color: "white",
                  textTransform: "none",
                  px: 2,
                  width: "100px",
                  borderRadius: "10px",
                  mt: 1,
                }}
              >
                Apply
              </Button>
            </Paper>
            <img
              style={{
                width: "100%",
                height: "250px",
                marginTop: "20px",
                borderRadius: "10px",
              }}
              src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
              alt="flight_ad"
            />
            <img
              style={{
                width: "100%",
                height: "250px",
                marginTop: "20px",
                borderRadius: "10px",
              }}
              src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
              alt="flight_ad"
            />
            <img
              style={{
                width: "100%",
                height: "250px",
                marginTop: "20px",
                borderRadius: "10px",
              }}
              src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
              alt="flight_ad"
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default RoundBookingDetails;
